// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2":"7237810f","90":"63daca0a","220":"1e9f396d","288":"c1975781","436":"9abf7789","630":"30adfd18","759":"eee16898","953":"30adfd18"}[chunkId] + ".chunk.css";
};